<template>
    <div id="doyen">
        <template v-if="app.template.type === '92fanli'">
            <header class="Mybar bg_white">
                <div class="myTitle">{{title}}</div>
            </header>
            <main class="MainCon">
                <NTfanliDoyen
                        :list="doyenData.list"
                        v-on:loadMore="fetchDoyenList"
                        v-on:scrollToTop="setScrollToTop"
                        ref="doyenList"
                />
            </main>
            <NTfanliBottomBar :style-name="app.template.style" />
        </template>
        <template v-else-if="app.template.type === 'damai'">
            <header class="Mybar bg_white">
                <div class="myTitle">{{title}}</div>
            </header>
            <main class="MainCon">
                <DamaiDoyen
                        :list="doyenData.list"
                        v-on:loadMore="fetchDoyenList"
                        v-on:scrollToTop="setScrollToTop"
                        ref="doyenList"
                />
            </main>
            <DamaiBottomBar :style-name="app.template.style" />
        </template>
        <template v-else>
            <header class="Mybar"
                    :class="{'bg_use': app.template.style === 'main','bg_red': app.template.style === 'main_b','bg_green': app.template.style === 'main_c'}">
                <div class="myTitle color_fff">{{title}}</div>
            </header>
            <main class="MainCon">
                <IfanliDoyen
                        :list="doyenData.list"
                        v-on:loadMore="fetchDoyenList"
                        v-on:scrollToTop="setScrollToTop"
                        ref="doyenList"
                />
            </main>
            <IfanliBottomBar :style-name="app.template.style" />
        </template>
    </div>
</template>

<script>
    import {mapMutations, mapState} from 'vuex';
    import IfanliBottomBar from './ifanli/BottomBar';
    import NTfanliBottomBar from './92fanli/BottomBar';
    import DamaiBottomBar from './damai/BottomBar';
    import IfanliDoyen from './ifanli/Doyen';
    import NTfanliDoyen from './92fanli/Doyen';
    import DamaiDoyen from './damai/Doyen';
    import {appService} from '../services/app';
    import {config} from '../libs/config';
    import {isMobile} from "../libs/utils";

    export default {
        components: {
            IfanliBottomBar,
            NTfanliBottomBar,
            DamaiBottomBar,
            IfanliDoyen,
            NTfanliDoyen,
            DamaiDoyen
        },
        data() {
            return {
                title: '达人圈',
                doyenData: {
                    isMore: true,
                    loading: false,
                    list: [],
                    pageNum: 1
                },
                scrollTop: 0
            }
        },
        computed: {
            ...mapState(['app'])
        },
        created() {
            if (!isMobile()) {
                window.location.href = window.location.origin + '/goods/worthbuy';
            }

            this.fetchDoyenList({init: true});
        },
        mounted() {
            this.setBottomBarIndex(2);
        },
        watch: {
            '$route'(param) {
                if (param.name === 'doyen') {
                    this.setBottomBarIndex(2);
                    this.$refs.doyenList.toTop(this.app.recruitScrollY);
                    this.$store.commit('changeRecruitScrollY', 0);
                }
            }
        },
        beforeRouteLeave(to, from, next) {
            this.$store.commit('changeRecruitScrollY', this.scrollTop)
            next()
        },
        methods: {
            ...mapMutations([
                'setBottomBarIndex'
            ]),
            fetchDoyenList: function ({init = false} = {}) {
                let self = this;

                if (self.doyenData.isMore === true && self.doyenData.loading === false) {
                    self.doyenData.loading = true;

                    appService.fetchDoyenList({
                        pageNum: self.doyenData.pageNum,
                        pageSize: config.PAGE_SIZE
                    }).then((res) => {
                        let {code, data: {list}} = res;
                        if (code === 200) {
                            if (list !== null && list.length > 0) {
                                for (let i = 0; i < list.length; i++) {
                                    if (list[i]['quality_images']) {
                                        list[i]['quality_images'] = JSON.parse(list[i]['quality_images']);
                                    }
                                }

                                if (init) {
                                    self.doyenData.list = list;
                                } else {
                                    for (let i = 0; i < list.length; i++) {
                                        self.doyenData.list.push(list[i]);
                                    }
                                }

                                self.doyenData.isMore = true;
                                self.doyenData.pageNum++;
                            } else {
                                self.doyenData.isMore = false;
                            }
                        }
                        self.doyenData.loading = false;
                    });
                }
            },
            setScrollToTop: function (top) {
                this.scrollTop = top;
            }
        }
    }
</script>

<style scoped>

</style>
